
import ValidatorInterface from './ValidatorInterface';

import ValidatorString from './validators/String';
import ValidatorSingle from './validators/Single';
import ValidatorEmail from './validators/Email';
import ValidatorDate from './validators/Date';
import ValidatorMultiple from './validators/Multiple';
import ValidatorNumber from './validators/Number';
import ValidatorLocale from "./validators/Locale";
import ValidatorPhone from "./validators/Phone";

import DataVariableInterface from "../../DataVariables/ts/DataVariableInterface";

export default class ValidatorFactory {

    static getInstance<T>(dataVariable: DataVariableInterface) : ValidatorInterface {

        switch(dataVariable.type) {
            case 'text': return new ValidatorString(dataVariable);
            case 'keyword': return new ValidatorString(dataVariable);
            case 'radio': return new ValidatorSingle(dataVariable);
            case 'number': return new ValidatorNumber(dataVariable);
            case 'email': return new ValidatorEmail(dataVariable);
            case 'date': return new ValidatorDate(dataVariable);
            case 'checkbox': return new ValidatorMultiple(dataVariable);
            case 'locale': return new ValidatorLocale(dataVariable);
            case 'phone': return new ValidatorPhone(dataVariable);
            default: {
                throw Error("No validator found for " + dataVariable.type);
            }
        }
    }

    static getTypes() : Array<string> {

        return ['text','keyword','radio','date','checkbox','number','email','locale','phone'];
    }
}
